import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlog, LazyBlogButton, LazyBlogContentBanner, LazyBlogContentBlog, LazyBlogContentButton, LazyBlogContentComments, LazyBlogContentComponent, LazyBlogContentContainer, LazyBlogContentDropper, LazyBlogContentFile, LazyBlogContentHeading, LazyBlogContentHr, LazyBlogContentHtml, LazyBlogContentMeta, LazyBlogContentParagraph, LazyBlogContentToc, LazyBlogContentWysiwyg, LazyBlogContentEditDropper, LazyBlogContentEditWrapper, LazyBlogContents, LazyBlogContentsEdit, LazyBlogContentsShow, LazyBlogDirectories, LazyBlogDirectoryNode, LazyBlogEditorAddzone, LazyBlogEditorSettingsActions, LazyBlogEditorSettingsFiles, LazyBlogEditorSettings, LazyBlogEditorSettingsWords, LazyBlogEditorSettingsDroppers, LazyBlogEditorTopPanel, LazyBlogElement, LazyBlogElementAdminHoverable, LazyBlogElements, LazyBlogExcerpt, LazyBlogExcerptVertical, LazyBlogFiles, LazyBlogNoContent, LazyBlogSettings, LazyBlogSettingsTags, LazyUiLink, LazyUniqueLicensesCompletionsList, LazyUniqueStats, LazyWikiAlphabetPronounciation, LazyWikiBlogAlphabetIndex, LazyWikiMiscPronounciation, LazyWikiNumberPronounciation, LazyWikiPictoAirport, LazyWikiTableFacilities, LazyWikiTableFlightconditions, LazyWikiTableFlightrules, LazyWikiTableNotations, LazyWikiTablePhraseology } from '#components'
const lazyGlobalComponents = [
  ["Blog", LazyBlog],
["BlogButton", LazyBlogButton],
["BlogContentBanner", LazyBlogContentBanner],
["BlogContentBlog", LazyBlogContentBlog],
["BlogContentButton", LazyBlogContentButton],
["BlogContentComments", LazyBlogContentComments],
["BlogContentComponent", LazyBlogContentComponent],
["BlogContentContainer", LazyBlogContentContainer],
["BlogContentDropper", LazyBlogContentDropper],
["BlogContentFile", LazyBlogContentFile],
["BlogContentHeading", LazyBlogContentHeading],
["BlogContentHr", LazyBlogContentHr],
["BlogContentHtml", LazyBlogContentHtml],
["BlogContentMeta", LazyBlogContentMeta],
["BlogContentParagraph", LazyBlogContentParagraph],
["BlogContentToc", LazyBlogContentToc],
["BlogContentWysiwyg", LazyBlogContentWysiwyg],
["BlogContentEditDropper", LazyBlogContentEditDropper],
["BlogContentEditWrapper", LazyBlogContentEditWrapper],
["BlogContents", LazyBlogContents],
["BlogContentsEdit", LazyBlogContentsEdit],
["BlogContentsShow", LazyBlogContentsShow],
["BlogDirectories", LazyBlogDirectories],
["BlogDirectoryNode", LazyBlogDirectoryNode],
["BlogEditorAddzone", LazyBlogEditorAddzone],
["BlogEditorSettingsActions", LazyBlogEditorSettingsActions],
["BlogEditorSettingsFiles", LazyBlogEditorSettingsFiles],
["BlogEditorSettings", LazyBlogEditorSettings],
["BlogEditorSettingsWords", LazyBlogEditorSettingsWords],
["BlogEditorSettingsDroppers", LazyBlogEditorSettingsDroppers],
["BlogEditorTopPanel", LazyBlogEditorTopPanel],
["BlogElement", LazyBlogElement],
["BlogElementAdminHoverable", LazyBlogElementAdminHoverable],
["BlogElements", LazyBlogElements],
["BlogExcerpt", LazyBlogExcerpt],
["BlogExcerptVertical", LazyBlogExcerptVertical],
["BlogFiles", LazyBlogFiles],
["BlogNoContent", LazyBlogNoContent],
["BlogSettings", LazyBlogSettings],
["BlogSettingsTags", LazyBlogSettingsTags],
["UiLink", LazyUiLink],
["UniqueLicensesCompletionsList", LazyUniqueLicensesCompletionsList],
["UniqueStats", LazyUniqueStats],
["WikiAlphabetPronounciation", LazyWikiAlphabetPronounciation],
["WikiBlogAlphabetIndex", LazyWikiBlogAlphabetIndex],
["WikiMiscPronounciation", LazyWikiMiscPronounciation],
["WikiNumberPronounciation", LazyWikiNumberPronounciation],
["WikiPictoAirport", LazyWikiPictoAirport],
["WikiTableFacilities", LazyWikiTableFacilities],
["WikiTableFlightconditions", LazyWikiTableFlightconditions],
["WikiTableFlightrules", LazyWikiTableFlightrules],
["WikiTableNotations", LazyWikiTableNotations],
["WikiTablePhraseology", LazyWikiTablePhraseology],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
